import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import chartsApi from '@/api/charts';


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props, { expose: __expose }) {
  __expose();

let mangaList = ref([]);

onMounted(async () => {
    const res = await chartsApi.ranking(10);
    mangaList.value = res.request;
})

const __returned__ = { get mangaList() { return mangaList }, set mangaList(v) { mangaList = v } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})